<svg [ngStyle]="{width, height}">
  <title>{{ title ? title : icon }}</title>
  <use attr.xlink:href="assets/svgDefs.svg#{{ icon }}"></use>
</svg>
